import React from 'react';
import propTypes from 'prop-types';
import styled from '@emotion/styled';
import {Grid, Box} from '@mui/material';

import Slider from '../../multimedia/Slider';
import IconText from '../IconText';
import {theme} from '../../../themes/default-theme';
import Text from '../../typography';

const Container = styled.div`
  position: relative;

  ${props => props.length > 1 && `
    padding-bottom: 50px;
  `}

  ${theme.breakpoints.up("md")} {
    ${props => props.length > 3 ? `
      padding-bottom: 60px;
    ` : `
      padding-bottom: 0;
    `}
  }

  .slick-next,
  .slick-prev {
    position: absolute;
    bottom: -40px;
    left: 0;
    right: 0;
    margin: auto;

    ${theme.breakpoints.up("md")} {
      bottom: -60px;
    }
  }

  .slick-prev {
    transform: translateX(-20px);

    ${theme.breakpoints.up("md")} {
      transform: translateX(-30px);
    }

  }

  .slick-next {
    transform: translateX(20px);

    ${theme.breakpoints.up("md")} {
      transform: translateX(30px);
    }
  }

`

const TextContainer = styled.div`
  margin-bottom: 20px;
  ${theme.breakpoints.up("md")} {
    margin-bottom: 60px;
  }
`

const iconTextCarouselDefaultPropItems = [];
const iconTextCarouselDefaultPropSettings = {};

const IconTextCarousel = ({
  heading = null,
  items = iconTextCarouselDefaultPropItems,
  settings = iconTextCarouselDefaultPropSettings,
  hTag
}) => {

  const slickSettings = {
    arrows: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    fade: false,
    slide: true,
    centerMode: false,
    variableWidth: false,
    focusOnSelect: true,
    responsive: [
      {
        breakpoint: theme.breakpoints.values.sm,
        settings: {
          slidesToShow: 1
        }
      }
    ],
    ...settings,
  }

  return (
    <Container length={items.length}>
      {heading &&
        <Grid container className={'hasPadding'} spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'}>
          <Grid size={12}>
            <Box px={2}>
              <TextContainer>
                <Text variant="h2" element={hTag ? hTag : 'h2'} colour="charcoal" uppercase={true} align="center">{heading}</Text>
              </TextContainer>
            </Box>
          </Grid>
        </Grid>
      }
      <Grid container spacing={0} direction={'row'} wrap="nowrap" justifyContent={'space-between'} alignItems={'flex-start'}>
        <Grid size={12}>
          <Slider settings={slickSettings} arrowProps={{
            skyBlue: true,
            grey: false
          }}>
            {items.map((item, index) => (
              <IconText 
                key={item.id || index}
                {...item}
              />
            ))}
          </Slider>
        </Grid>
      </Grid>
    </Container>
  );
}

IconTextCarousel.propTypes = {
  heading: propTypes.string,
  items: propTypes.array.isRequired,
  settings: propTypes.object,
}

export default IconTextCarousel
